import { styled } from "@mui/material/styles";

// @ts-ignore
const Image = styled("img")({});

export default Image;
